module.exports = __webpack_public_path__ + "img/818.bf2c652b.png";